// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_Cye","cls2":"ProfilePdfPackCard-cls2_lcr ProfilePdfPackCard-cls1_Cye"};